import { render, staticRenderFns } from "./AppChat.vue?vue&type=template&id=473673c4&"
import script from "./AppChat.vue?vue&type=script&lang=ts&"
export * from "./AppChat.vue?vue&type=script&lang=ts&"
import style0 from "./AppChat.vue?vue&type=style&index=0&id=473673c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports